import { ListResult, Tunnel, TunnelFilter, TunnelInit, TunnelOutputInfo, TunnelType } from 'common/api/v1/types'
import { EdgeClient } from 'common/generated/edgeClient'
import { PaginatedRequestParams, singleSortQueryFromPaginatedRequestParams, TunnelsRequestParams } from '../nm-types'
import { Query } from 'common/query'

export class TunnelApi {
  constructor(private readonly edgeClient: EdgeClient) {}

  createTunnel(tunnel: TunnelInit): Promise<Tunnel> {
    return this.edgeClient.setTunnel(tunnel)
  }

  updateTunnel(id: Tunnel['id'], tunnel: TunnelInit): Promise<Tunnel> {
    return this.edgeClient.updateTunnel(id.toString(), tunnel)
  }

  deleteTunnel(id: number) {
    return this.edgeClient.deleteTunnel(id.toString())
  }

  getTunnels({ id, type, appliances, clientName, serverName, ...paginatedRequestParams }: TunnelsRequestParams) {
    const filter: TunnelFilter = {
      ids: id !== undefined && !isNaN(parseInt(id)) ? [parseInt(id).toString()] : undefined,
      type: type !== undefined && typeof TunnelType[type] === 'string' ? type : undefined,
      applianceNames: appliances?.split(','),
      clientName,
      serverName,
    }
    const query = singleSortQueryFromPaginatedRequestParams({ filter, paginatedRequestParams })
    return this.listTunnels(query)
  }

  listTunnels(query: Query<TunnelFilter>): Promise<ListResult<Tunnel>> {
    return this.edgeClient.listTunnels(query)
  }

  listTunnelOutputs(id: number, paginatedRequestParams: PaginatedRequestParams): Promise<ListResult<TunnelOutputInfo>> {
    const filter = undefined
    const query = singleSortQueryFromPaginatedRequestParams({ filter, paginatedRequestParams })
    return this.edgeClient.listTunnelOutputs(id.toString(), query)
  }

  recreateTunnel(id: number): Promise<void> {
    return this.edgeClient.recreateTunnel(id.toString())
  }
}
